import en from "@/locale/en";
import fr from "@/locale/fr";
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fr, en },
    current: "fr"
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        primary: "#00758F",
        secondary: "#F5DF4D",
        accent: "#FFA500",
        error: "#CD212A",
        info: "#f3c300",
        background: "#242424"
      },
      light: {
        primary: "#282D3C",
        secondary: "#FA7A35",
        accent: "#6B5876",
        error: "#9C4722",
        info: "#272929",
        background: "#EDD59E"
      }
    }
  },
  options: {
    customProperties: true
  }
});
